import HTTPService from "@/services/http_service.js";

export default class AgendaService extends HTTPService {
  resource = "agenda";

  static build() {
    return new AgendaService();
  }

  getAgendaMedico(
    responseFunctions,
    idMedico,
    paginationComponent,
    filtro = {}
  ) {
    const pagination = paginationComponent
      ? {
          page: paginationComponent.page,
          per_page: paginationComponent.itemsPerPage,
        }
      : {};
    const id_unidade = ~~JSON.parse(sessionStorage.vuex).unidade?.id;
    const queryParams = { ...pagination, ...filtro, id_unidade };
    if (idMedico) {
      queryParams.id_medico = idMedico;
    }
    this.request(responseFunctions, "GET", this.resource, null, queryParams);
  }

  getAgendaMedicoEspecialidade(
    responseFunctions,
    paginationComponent,
    filtro = {}
  ) {
    const pagination = paginationComponent
      ? {
          page: paginationComponent.page,
          per_page: paginationComponent.itemsPerPage,
        }
      : {};
    const id_unidade = ~~JSON.parse(sessionStorage.vuex).unidade?.id;
    const queryParams = { ...pagination, ...filtro, id_unidade };
    this.request(
      responseFunctions,
      "GET",
      `${this.resource}/especialidade`,
      null,
      queryParams
    );
  }

  getAgendaList(responseFunctions, idMedico, options) {
    if (idMedico) {
      options.id_medico = idMedico;
    }
    options.id_unidade = ~~JSON.parse(sessionStorage.vuex).unidade?.id;
    this.request(responseFunctions, "GET", this.resource, null, options);
  }

  getAgendaEspecialidadeList(responseFunctions, options) {
    options.id_unidade = ~~JSON.parse(sessionStorage.vuex).unidade?.id;
    this.request(
      responseFunctions,
      "GET",
      this.resource + "/especialidade",
      null,
      options
    );
  }

  agendar(responseFunctions, request) {
    const uri = "agendamento";
    this.request(responseFunctions, "POST", uri, request);
  }

  agendar_paciente(responseFunctions, request) {
    const uri = "agendamento/cliente";
    this.request(responseFunctions, "POST", uri, request);
  }

  criarHorario(responseFunctions, req) {
    this.request(responseFunctions, "POST", this.resource, req);
  }

  criarAgenda(responseFunctions, req) {
    this.request(responseFunctions, "POST", this.resource, req);
  }

  criarAgendaEspecialidadeUnica(responseFunctions, req) {
    this.request(
      responseFunctions,
      "POST",
      this.resource + "/especialidade",
      req
    );
  }

  criarAgendaMedicoUnica(responseFunctions, req) {
    this.request(responseFunctions, "POST", this.resource + "/medico", req);
  }

  criarAgendaMultiplo(responseFunctions, params) {
    this.request(
      responseFunctions,
      "POST",
      this.resource + "/multiplos",
      params
    );
  }

  criarAgendaEspecialidade(responseFunctions, params) {
    this.request(
      responseFunctions,
      "POST",
      this.resource + "/especialidade/multiplos",
      params
    );
  }

  criarAgendaMedicoMultiplos(responseFunctions, params) {
    this.request(
      responseFunctions,
      "POST",
      this.resource + "/medico/multiplos",
      params
    );
  }

  atualizarTipoProcedimentoDeAgenda(
    responseFunctions,
    idTipoProcedimento,
    agendaID
  ) {
    const url = `${this.resource}/${agendaID}`;
    this.request(responseFunctions, "POST", url, {
      id_tipo_procedimento: idTipoProcedimento,
      alterado_por: 1,
    });
  }

  atualizarEspecialidadeDeAgenda(responseFunctions, especialidadeId, agendaID) {
    const url = `${this.resource}/especialidade/${agendaID}`;
    this.request(responseFunctions, "POST", url, {
      id_especialidade: especialidadeId,
      alterado_por: 1,
    });
  }

  excluirAgenda(responseFunctions, agendaID) {
    // ESTÁ SENDO UTILIZADO POST PARA EXCLUSÃO PORQUE A UMBLER INFORMOU ERRO DE CORS AO USAR O MÉTODO DELETE. CORRIGIR.
    const url = `${this.resource}/${agendaID}/deletar`;
    this.request(responseFunctions, "POST", url);
  }

  excluirAgendaEspecialidade(responseFunctions, agendaID) {
    // ESTÁ SENDO UTILIZADO POST PARA EXCLUSÃO PORQUE A UMBLER INFORMOU ERRO DE CORS AO USAR O MÉTODO DELETE. CORRIGIR.
    const url = `${this.resource}/especialidade/${agendaID}/deletar`;
    this.request(responseFunctions, "POST", url);
  }

  getAgendamentoByDia(data, unidadeId) {
    return this.get(`agenda/resumo/unidade/${unidadeId}/data/${data}`);
  }
  async getAgendaByEspecialidadeUnidadePeriodo(
    especialidadeId,
    unidadeId,
    dataInicial,
    dataFinal,
    { page, per_page }
  ) {
    console.log(
      `
      especialidadeId: ${especialidadeId}, 
      unidadeId: ${unidadeId}, 
      dataInicial: ${dataInicial},
      dataFinal: ${dataFinal},
      page: ${page}, 
      per_page: ${per_page},
      `
    );
    return await this.get(
      `agenda/unidade/especialidade/lista/${especialidadeId}/${unidadeId}/${dataInicial}/${dataFinal}`,
      {
        page,
        per_page,
      }
    );
  }
}
